module.exports = __webpack_public_path__ + "img/service05.f592796b.png";